<template>
  <div>
    <footer class="nav-footer-wrap">
      <div class="nav-footer-list">
        <div v-for="item in navItems" :key="item.path" class="nav-footer-item" @click="open(item.path)">
          <img :src="isActive(item.path) ? item.iconActive : item.iconNo" class="nav-icon" alt="" />
          <span class="item-text">{{ item.name }}</span>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      navItems: [
        { name: '首页', path: '/', iconNo: '/static/nav/home-no.png', iconActive: '/static/nav/home.png' },
        { name: '分类', path: '/categories', iconNo: '/static/nav/cate-no.png', iconActive: '/static/nav/cate.png' },
        { name: '积分商城', path: '/pointsmall', iconNo: '/static/nav/shop-no.png', iconActive: '/static/nav/shop.png' },
        { name: '我的', path: '/user', iconNo: '/static/nav/user-no.png', iconActive: '/static/nav/user.png' }
      ]
    };
  },
  computed: {
    activeNav() {
      return this.$route.path;
    }
  },
  methods: {
    isActive(path) {
      return this.activeNav === path;
    },
    open(path) {
      this.$router.push({ path });
    }
  }
};
</script>

<style scoped>
.nav-footer-wrap {
  width: 100%;
  height: 2.6rem;
  padding-top: 10px;
  position: fixed;
  bottom: 0;
  background-color: #fff;
  box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.05);
}

.nav-footer-list {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-around;
}

.nav-footer-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  cursor: pointer;
}

.nav-icon {
  width: 1.2rem;
  height: 1.2rem;
  margin-bottom: 0.2rem;
}

.item-text {
  font-size: 0.7rem;
  font-weight: 400;
  color: #000000;
  text-align: center;
}
</style>


// WEBPACK FOOTER //
// src/components/NavFooter.vue